export default "__VITE_ASSET__BCEXF7nH__"